// Fuente única de los colores semánticos del módulo de mantención.
// Son convención de seguridad (verde pasa / rojo detención / severidad) y por
// eso NO se sobrescriben por tenant: se importan de las constantes de marca,
// no del token (que sí lleva el override). El color "activo/acento" (segmented,
// progreso, chips) sí sale de token.colorPrimary en cada componente.
import { successColor, signalColor, warningColor, errorColor, infoColor, neutral } from 'assets/theme/colors';

export const MAINT_STATE_COLOR = {
  EXITOSO: successColor,
  RECHAZADO: infoColor, // "Con problema" = información (hallazgo registrado), NO error
  NA: neutral.textFade,
};

export const SEVERIDAD_OPTIONS = [
  { value: 'BAJA', label: 'Baja', color: successColor },
  { value: 'MEDIA', label: 'Media', color: signalColor },
  { value: 'ALTA', label: 'Alta', color: warningColor },
  { value: 'CRITICA', label: 'Crítica', color: errorColor },
];

export function severidadColor(sev) {
  const found = SEVERIDAD_OPTIONS.find((o) => o.value === sev);
  return found ? found.color : neutral.textFade;
}
